import { filter, forEach, isEmpty, map, size } from 'lodash-es'

const calculateChildDishCount = (menuTitle, allMenuTitles) => {
  let sum = 0

  const children = filter(
    allMenuTitles,
    ({ parentId }) => parentId === menuTitle.id,
  )

  if (isEmpty(children)) return 0

  sum += size(filter(children, ({ dishCount }) => dishCount > 0))

  forEach(children, childMenuTitle => {
    sum += calculateChildDishCount(childMenuTitle, allMenuTitles)
  })

  return sum
}

const processUploadedMenuData = uploadedJsonData => {
  const menuTitlesWithDishCount = map(
    uploadedJsonData.menuTitles,
    menuTitle => {
      const dishCount = size(
        filter(
          uploadedJsonData.dishes,
          dish => dish.menuTitleId === menuTitle.id,
        ),
      )
      return {
        ...menuTitle,
        isEverywhereAvailable: true,
        dishCount,
      }
    },
  )

  const menuTitlesWithChildDishCount = map(
    menuTitlesWithDishCount,
    menuTitle => ({
      ...menuTitle,
      childDishCount: calculateChildDishCount(
        menuTitle,
        menuTitlesWithDishCount,
      ),
    }),
  )

  return {
    ...uploadedJsonData,
    menuTitles: menuTitlesWithChildDishCount,
  }
}

export default processUploadedMenuData
